import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import { configureChart, generateSeries } from '@app/widgets/helpers/widget-helpers';

export const PanoniMahurangiRiver: BasicCartesianChartConfig = configureChart(
  'Panoni - Land Use Change Over Time: Mahurangi River',
  generateSeries(
    ['arc_Mahurangi_Argonaut_@_College'],
    [
      'relative-water-level',
      'dissolved-oxygen-in-field',
      'dissolved-oxygen-saturation-in-field',
      'River flow',
      'water-temperature',
    ]
  )
);

export const PanoniHoteoRiverGubbs: BasicCartesianChartConfig = configureChart(
  'Panoni - Land Use Change Over Time: Hoteo River Gubbs',
  generateSeries(['arc_Hoteo_River_@_Gubbs'], ['relative-water-level', 'River flow', 'water-temperature'])
);

export const PanoniLongbay: BasicCartesianChartConfig = configureChart(
  'Panoni - Land Use Change Over Time: Long Bay',
  generateSeries(
    ['arc_Vaughn_Stream_@_Lower_Weir'],
    ['dissolved-oxygen-in-field', 'dissolved-oxygen-saturation-in-field', 'relative-water-level', 'River flow']
  )
);

export const PanoniOrewa: BasicCartesianChartConfig = configureChart(
  'Panoni - Land Use Change Over Time: Orewa',
  generateSeries(
    ['arc_West_Hoe_@_Halls'],
    [
      'dissolved-oxygen-in-field',
      'dissolved-oxygen-saturation-in-field',
      'relative-water-level',
      'River flow',
      'water-temperature',
    ]
  )
);

export const PanoniPuhoi: BasicCartesianChartConfig = configureChart(
  'Panoni - Land Use Change Over Time: Puhoi',
  generateSeries(
    ['arc_Te_Muri'],
    ['dissolved-oxygen-in-field', 'dissolved-oxygen-saturation-in-field', 'relative-water-level', 'River flow']
  ).concat(generateSeries(['arc_Te_Muri_Rainfall'], ['precipitation']))
);

export const RainfallA: BasicCartesianChartConfig = configureChart(
  'UA - Rainfall Group A',
  generateSeries(
    [
      'arc_Orewa_@_Treatment_Ponds',
      'arc_Mairangi_Bay_NSCC02',
      'arc_Albany_at_Hts_Rd_NSCC06',
      'arc_Rosedale_WWTP_Watercare',
      'arc_Takapuna_Library',
      'arc_Torbay_Glamorgan_Schl_NSCC04',
    ],
    ['precipitation'],
    {
      useDataSourceColours: true,
    }
  ),
  {
    includeAnalyteInName: false,
    includeUnitsInName: false,
  }
);

export const RainfallB: BasicCartesianChartConfig = configureChart(
  'UA - Rainfall Group B',
  generateSeries(
    [
      'arc_Leigh_Rainfall',
      'arc_Mahurangi_@_Warkworth_Sewage_Treatment_Plant',
      'arc_Hoteo_at_Oldfields',
      'arc_Tomarata_at_Briens_Farm',
      'arc_Te_Muri_Rainfall',
      'arc_Tamahunga_Quintals_Rd',
      'arc_Omaha_Rain_Golf_Course',
    ],
    ['precipitation'],
    {
      useDataSourceColours: true,
    }
  ),
  {
    includeAnalyteInName: false,
    includeUnitsInName: false,
  }
);

export const UAWellsford: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Wellsford',
  generateSeries(['arc_Awaruku_stream_@_Glenvar_Road'], ['relative-water-level', 'River flow'])
);

export const UAMilldale: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Milldale',
  generateSeries(['arc_Orewa_@_Kowhai_Ave'], ['relative-water-level', 'River flow'])
);

export const UATorbay: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Torbay',
  generateSeries(['arc_Awaruku_stream_@_Glenvar_Road'], ['relative-water-level', 'River flow'])
);

export const UAMairangiBay: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Mairangi Bay',
  generateSeries(['arc_Mairangi_Bay_Stream_@_Tennis_Club'], ['relative-water-level', 'River flow'])
);

export const UABrownsBay: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Browns Bay',
  generateSeries(['arc_Taiaotea_stream_@_Freyberg_Park'], ['relative-water-level', 'River flow'])
);

export const UAAlbany: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Albany',
  generateSeries(['arc_Oteha_River_@_Days_Bridge'], ['relative-water-level', 'River flow'])
);

export const UAWhangateau: BasicCartesianChartConfig = configureChart(
  'Wai - Flow and Levels: Whangateau',
  generateSeries(['arc_Tamahunga_River_@_Quintals_Falls'], ['relative-water-level', 'River flow'])
);
